import { render, staticRenderFns } from "./waterQualityData.vue?vue&type=template&id=b7490f74&"
import script from "./waterQualityData.vue?vue&type=script&lang=js&"
export * from "./waterQualityData.vue?vue&type=script&lang=js&"
import style0 from "./waterQualityData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports